import moment from 'moment';
export default {
    add:{
        date_achat:{
            presence: {
                allowEmpty: false,
                message:"est obligatoire"
            },
            datetime: {
                dateOnly: true,
                latest:moment().format('YYYY-MM-DD'),
                message :"date incorrect"
                // latest: moment.utc().subtract(18, 'years'),
                // message: "^You need to be at least 18 years old"
            }
        },
        immatriculation:{
            presence: {
                allowEmpty: false,
                message:"est obligatoire"
            }
        },
        numero_chassis:{
            presence: {
                allowEmpty: false,
                message:"est obligatoire"
            }
        },
        modele:{
            presence: {
                allowEmpty: false,
                message:"est obligatoire"
            }
        },
        carburant:{
            presence: {
                allowEmpty: false,
                message:"est obligatoire"
            }
        },
        prix_achat:{
            presence: {
                allowEmpty: false,
                message:"est obligatoire"
            },
            numericality:{
                greaterThan:0,
                message:" doit être superieur à 0"
            },
        },        
        nbre_km_achat:{
            presence: {
                allowEmpty: false,
                message:"est obligatoire"
            },
            numericality:{
                greaterThan:0,
                message:" doit être superieur à 0"
            },
        },        
    }
}